<template>
    <div id="editQuestionLoadingDiv" class="vs-con-loading__container">

        <vs-alert color="danger" title="Requested Question Not Found" :active.sync="question_not_found">
            <span>Question record with id: {{ $route.params.questionId }} not found. </span>
            <span>
                <span>Check </span><router-link :to="{ name: 'questions' }" class="text-inherit underline">All
                    Questions</router-link>
            </span>
        </vs-alert>

        <div id="module-data" v-if="question_data">
            <vx-card class="mb-base" style="min-height: 600px;">
                <form data-vv-scope="editQuestionForm">

                    <div class="vx-row mb-base ">
                        <div class="vx-col w-12/12 mb-2">
                            Language
                            <vs-switch class="w-full" color="success" v-model="lang">
                                <span slot="on">English</span>
                                <span slot="off">Danish</span>
                            </vs-switch>
                        </div>
                    </div>
                    <div class="vx-row mb-base">
                        <div class="vx-col w-12/12  mb-2">
                            <div class="flex items-start flex-col sm:flex-row">
                                <img height="200px" :src="question_data.picture" class="mr-8 rounded" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-base">
                        <div class="vx-col w-12/12 mb-2">
                            <croppa key="3" :width="500" :height="350" placeholder="Choose image" :placeholder-font-size="16"
                                :prevent-white-space="true" v-model="myCroppa"></croppa>
                            <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.picture')">{{
                                errors.first('addQuestionForm.picture') }}</span>
                        </div>

                        <!-- <div class="vx-col w-6/12 mb-2">
                        <VueFileAgent
                          ref="vueFileAgendsdt"
                          :theme="'list'"
                          :multiple="false"
                          :deletable="true"
                          :meta="true"
                          :compact="true"
                          :accept="'image/*'"
                          :maxSize="'5MB'"
                          :helpText="'Choose image'"
                          :errorText="{
                            type: 'Invalid file type. Only image Allowed',
                            size: 'Files should not exceed 5MB in size',
                          }"
                          @select="filesSelected($event)"
                          @beforedelete="onBeforeDelete($event)"
                          @delete="fileDeleted($event)"
                          v-model="file"
                        ></VueFileAgent>
                      </div> -->

                    </div>

                    <vs-divider position="left"> Categories </vs-divider>

                    <div class="flex flex-wrap items-center justify-end vx-row mb-2 mb-base">
                        <div class="vx-col w-full mb-2">
                            <treeselect v-model="question_data.categories" :multiple="true"
                                :options="question_categories_options" />
                        </div>
                    </div>

                    <vs-divider />

                    <div class="vx-row mb-base">
                        <div class="vx-col sm:w-3/4">
                            Situation
                            <vs-textarea v-validate="'required'" name="name" ref="name" v-model="question_data.situation" />
                            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                        </div>
                        <div class="vx-col sm:w-1/4" v-if="question_data.situation_audio">
                            <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                :audio-list="[question_data.situation_audio]" theme-color="#00A99D" />
                        </div>
                    </div>

                    <vs-divider />

                    <vs-tabs>
                        <vs-tab label="Question 1">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q1" ref="q1"
                                        v-model="question_data.q1" />
                                    <span class="text-danger text-sm" v-show="errors.has('editQuestionForm.q1')">{{
                                        errors.first('editQuestionForm.q1') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a1">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q1_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q1_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q1_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Question 2">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q2" ref="q2"
                                        v-model="question_data.q2" />
                                    <span class="text-danger text-sm" v-show="errors.has('editQuestionForm.q2')">{{
                                        errors.first('editQuestionForm.q2') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a2">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q2_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q2_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q2_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Question 3">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q3" ref="q3"
                                        v-model="question_data.q3" />
                                    <span class="text-danger text-sm" v-show="errors.has('editQuestionForm.q3')">{{
                                        errors.first('editQuestionForm.q3') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a3">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q3_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q3_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q3_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Question 4">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q4" ref="q4"
                                        v-model="question_data.q4" />
                                    <span class="text-danger text-sm" v-show="errors.has('editQuestionForm.q4')">{{
                                        errors.first('editQuestionForm.q4') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a4">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q4_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q4_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q4_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                    </vs-tabs>

                    <vs-divider />

                    <div class="vx-row mt-base">
                        <div class="vx-col w-full" align="right">
                            <!-- <vs-button @click="" class="mt-4 mr-2 shadow-lg" type="gradient"
                                    color="danger" icon-pack="feather" icon="icon-trash" icon-after>Delete</vs-button> -->
                            <vs-button color="danger" @click="deleteQuestion(question_data)"
                                class="mr-3 mb-2">Delete</vs-button>
                            <vs-button @click="validateUpdateQuestion()" class="mr-3 mb-2">Save Changes</vs-button>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import Vue from 'vue'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'

Vue.use(Croppa) 

export default {
    data() {
        return {
            myCroppa: {},
            question_data: {
                categories: [],
            },
            file: [],
            fileRecordsForUpload: [],
            question_not_found: false,
            deleteQuestionData: null,
        }
    },
    components: {
        quillEditor,
        Treeselect,
    },
    computed: {
        question_categories_options() {
            let categories = this.$store.state.questionManagement.categories
            let categoriesData = []

            categories.forEach(function (entry, key) {
                categoriesData.push({
                    id: entry.id,
                    title: entry.name,
                    label: entry.name,
                })
            });

            return categoriesData
        },
        lang: {
            set: function (val) {
                this.question_data.lang = val ? "en" : "da";
            },
            get: function () {
                return this.question_data.lang == "en" ? true : false;
            }
        },
        a1: {
            set: function (val) {
                this.question_data.a1 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a1 == "true" ? true : false;
            }
        },
        a2: {
            set: function (val) {
                this.question_data.a2 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a2 == "true" ? true : false;
            }
        },
        a3: {
            set: function (val) {
                this.question_data.a3 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a3 == "true" ? true : false;
            }
        },
        a4: {
            set: function (val) {
                this.question_data.a4 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a4 == "true" ? true : false;
            }
        },
    },
    methods: {
        deleteQuestion(question) {
            console.log(question);
            this.deleteQuestionData = question;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure to delete this Question data ?',
                accept: this.acceptDeleteQuestiom
            })
        },
        acceptDeleteQuestiom() {
            this.$vs.loading();

            this.$store.dispatch("questionManagement/deleteQuestion", { id: this.deleteQuestionData.id })
                .then(res => {
                    this.$router.push("/questions").catch(() => { })
                    this.getAllQuestions()
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: "Success.",
                        text: "Question deleted successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                })
                .catch(err => {
                    this.$vs.loading.close()
                })
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.file.indexOf(fileRecord);
                if (k !== -1) this.file.splice(k, 1);
            } else {
                this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        redirectToAllPackages() {
            this.$router.push("/packages").catch(() => { })
        },
        validateUpdateQuestion() {
            this.$validator.validateAll('editQuestionForm').then(result => {
                if (result) this.updateQuestion()
            })
        },
        async updateQuestion() {
            var self = this

            this.$vs.loading({
                container: '#editQuestionLoadingDiv',
                scale: 0.6
            })

            let questionData = new FormData();
            questionData.append('id', this.question_data.id);
            questionData.append('question_id', this.question_data.id);

            questionData.append('lang', this.question_data.lang);
            questionData.append('situation', this.question_data.situation);

            questionData.append('q1', this.question_data.q1);
            questionData.append('a1', this.question_data.a1);
            questionData.append('q1_explanation', this.question_data.q1_explanation);

            questionData.append('q2', this.question_data.q2);
            questionData.append('a2', this.question_data.a2);
            questionData.append('q2_explanation', this.question_data.q2_explanation);

            questionData.append('q3', this.question_data.q3);
            questionData.append('a3', this.question_data.a3);
            questionData.append('q3_explanation', this.question_data.q3_explanation);

            questionData.append('q4', this.question_data.q4);
            questionData.append('a4', this.question_data.a4);
            questionData.append('q4_explanation', this.question_data.q4_explanation);

            if (this.question_data.categories.length) {
                for (let i = 0; i < this.question_data.categories.length; i++) {
                    questionData.append('categories[]', this.question_data.categories[i]);
                }
            }

            // if(this.file.length) questionData.append('picture', this.file[0].file); 
            const blob = await this.myCroppa.promisedBlob()
            if (this.myCroppa.hasImage()) questionData.append('picture', blob);

            for (var pair of questionData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }

            this.$store.dispatch("questionManagement/updateQuestion", questionData)
                .then(res => {
                    this.question_data = res.data.data
                    this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')

                    this.$vs.notify({
                        time: 4000,
                        title: 'Success',
                        text: 'Sussfully Updated.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });

                    //  navigate to questions page with pagination
                    this.$router.push("/questions").catch(() => { })
                })
                .catch(err => {
                    this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')

                    if (err.status && err.status == 422) {
                        Object.keys(err.data).forEach(function (key) {
                            self.errors.add({
                                field: key,
                                msg: err.data[key][0],
                            });
                        });
                    }
                })
        },
    },
    async mounted() {
        var self = this
        this.$vs.loading({
            container: '#editQuestionLoadingDiv',
            scale: 0.6
        })

        await this.$store.dispatch("questionManagement/viewCategoryWithoutPaginate", { avoid_paginate: "true" })

        const questionId = this.$route.params.questionId
        this.$store.dispatch("questionManagement/viewQuestion", questionId)
            .then(res => {
                this.question_data = res.data

                var catArray = [];
                if (res.data.category && res.data.category.length) {
                    for (let i = 0; i < res.data.category.length; i++) {
                        catArray.push(res.data.category[i].id)
                    }
                }

                this.question_data.categories = catArray
                this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')

            })
            .catch(err => {
                console.log(err)
                this.question_not_found = true
                this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')
            })



    },
    created() {
        if (!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }
    },

}
</script>
<style type="text/css">
::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

.vs-con-textarea textarea {
    height: 200px;
}
</style>

